define [], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./choice.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      if scope.field.required
        scope.required = true
      else
        scope.required = false

      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/choice/choice.coffee